import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export default function ModalInfo(props) {
  const { isOpen, toggle, modalContent, buttonName } = props;

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>{buttonName || ""}</ModalHeader>
        <ModalBody>
          <div
            id="div-set-email"
            dangerouslySetInnerHTML={{
              __html: modalContent || "",
            }}
          />
        </ModalBody>
      </Modal>
    </>
  );
}
